import { useEffect, useState } from 'react';

import { Field, ErrorMessage } from 'formik';

import { api, useAPIContext } from '../../api/context';
import toast from '../../utils/toast';

const Country = ({ loading }) => {

  const { token } = useAPIContext();
  const [ _loading, setLoading ] = useState(true);

  const [ items, setItems ] = useState([]);

  useEffect(() => {

    api(token).v1.profile.countries.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          setItems(res.body.items);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  return (
    <div>
      <label htmlFor='country'>Country</label>

      <Field
        id='country'
        as='select'
        aria-label='country'
        name='country'
        disabled={loading || _loading}>

        <option key='' value=''></option>

        {
          items.map(item => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))
        }

      </Field>

      <ErrorMessage
        name='country'
        component='div'
      />
    </div>
  );
};

export default Country;